import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { DboCloudOptimizationCandidatesResponse } from '@cast/types-database-optimizer';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.listCloudOptimizationCandidates;

const DBO_CLOUD_OPTIMIZATION_CANDIDATES_QUERY_KEY =
  'dbo-cloud-optimization-candidates';

const getCloudOptimizationCandidatesQueryKey = (
  params: Parameters<typeof apiFn>[0]
) => {
  return [DBO_CLOUD_OPTIMIZATION_CANDIDATES_QUERY_KEY, params] as const;
};

export const useCloudOptimizationCandidatesQuery = <
  TSelected = DboCloudOptimizationCandidatesResponse
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<DboCloudOptimizationCandidatesResponse, TSelected>
) =>
  useQuery(
    queryOptions({
      queryKey: getCloudOptimizationCandidatesQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      placeholderData: keepPreviousData,
      ...options,
    })
  );
